import { FilterValues } from "@kaltura/mediaspace-shared-types";
import SearchResults from "./search-results/SearchResults";
import { SearchResultsSkeleton } from "./search-results-skeleton/SearchResultsSkeleton";
import { SearchResultsContainer } from "@kaltura/mediaspace-shared-search";
import { useChannelsContext } from "../ChannelsContext";

export interface SearchResultsSectionProps {
    /**
     * filters values
     */
    filterValues: FilterValues;
}

const SearchResultsSection = (props: SearchResultsSectionProps) => {
    const { filterValues } = props;

    const { pageSize, searchUrl } = useChannelsContext();

    return (
        <div className={"kms-ds-channels-results-container"}>
            <SearchResultsContainer
                searchUrl={searchUrl}
                filterValues={filterValues}
                pageSize={pageSize}
                searchResultsDisplayComponent={SearchResults}
                searchResultsSkeletonComponent={SearchResultsSkeleton}
                onEntryShowMore={() => {}}
                isWideLayout={true}
            />
        </div>
    );
};

export default SearchResultsSection;
